import { gql } from "@apollo/client";

export const CREATE_TICKETING_ITEM = gql`
  mutation create_item_ticketing($input: items_ticketing_insert_input!) {
    insert_items_ticketing_one(object: $input) {
      id
    }
  }
`;

export const UPDATE_TICKETING_ITEM = gql`
  mutation update_items_ticketing($input: items_ticketing_set_input, $where: items_ticketing_bool_exp!) {
    update_items_ticketing(_set: $input, where: $where) {
      returning {
        id
      }
    }
  }
`;

export const DELETE_TICKETING_ITEM = gql`
   mutation DeleteTicketingItem($id: Int!) {
    delete_items_ticketing_by_pk(id: $id) {
      id
    }
  }
`;

export const UPSERT_TICKETING_TABS = gql`
  mutation upsert_items_ticketing_tabs($objects: [items_ticketing_tabs_insert_input!]!) {
    insert_items_ticketing_tabs(
      objects: $objects
      on_conflict: {
        constraint: items_ticketing_tabs_pkey
        update_columns: [name, sort_order, is_active, last_updated_by]
      }
    ) {
      returning {
        id
        name
        sort_order
        is_active
      }
    }
  }
`;

export const DELETE_TICKETING_TAB = gql`
  mutation delete_items_ticketing_tab($id: Int!) {
    delete_items_ticketing_tabs_by_pk(id: $id) {
      id
    }
  }
`;
